// extracted by mini-css-extract-plugin
export default {"loading":"AppLoading_loading__WnuJS","container":"AppLoading_container__wpR-j","logo":"AppLoading_logo__+YCxd"};